// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 8H3.45C4.02 8 4.29 7.72 4.45 7.18L5.66 2.34C5.77 1.9 6.4 1.89 6.53 2.33L9.47 13.67C9.6 14.11 10.23 14.1 10.34 13.66L11.55 8.82C11.7 8.28 11.99 8 12.55 8H14.5',
];
